import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { notify } from "../../util/notify";
import { imageurl } from "../../App";
import {
  getWishlist,
  removeFromWishlist,
} from "../../util/wishlistService";
import { addToGuestCart, openCartDrawer } from "../../util/guestCartService";
import { getProductImageUrl, handleProductImageError, applyStoreTitle } from "../../util/storeLogoHelper";
import {
  FaHeart,
  FaTrashAlt,
  FaShoppingBag,
  FaArrowRight
} from "react-icons/fa";

export default function Wishlist() {
  const [wishlistItems, setWishlistItems] = useState([]);

  const loadWishlist = () => {
    setWishlistItems(getWishlist());
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    applyStoreTitle(null, "My Wishlist");
    loadWishlist();

    const handleWishlistChange = () => {
      loadWishlist();
    };

    window.addEventListener("wishlistUpdated", handleWishlistChange);
    return () => {
      window.removeEventListener("wishlistUpdated", handleWishlistChange);
    };
  }, []);

  const handleRemove = (productId) => {
    removeFromWishlist(productId);
    notify("Removed from your wishlist", "info");
  };

  const handleMoveToCart = (item) => {
    addToGuestCart({
      id: item.id,
      name: item.name,
      slug: item.slug,
      categorySlug: item.categorySlug,
      categoryName: item.categoryName,
      image: item.image,
      price: item.price,
    }, 1);

    removeFromWishlist(item.id);
    notify("Moved to your cart");
    openCartDrawer();
  };

  return (
    <div>
      {/* Header Banner & Breadcrumbs */}
      <div className="page-header-modern">
        <div className="container">
          <ul className="breadcrumb-modern">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-separator">/</li>
            <li className="active">Wishlist</li>
          </ul>
          <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
            <h1 className="page-header-title">My Wishlist</h1>
            <span className="text-muted" style={{ fontSize: "14px", fontWeight: 600 }}>
              {wishlistItems.length} {wishlistItems.length === 1 ? "Item" : "Items"} Saved
            </span>
          </div>
        </div>
      </div>

      <div className="container py-4">
        {wishlistItems.length === 0 ? (
          <div className="empty-state-modern">
            <div className="empty-state-icon" style={{ background: "var(--danger-light)", color: "var(--danger)" }}>
              <FaHeart />
            </div>
            <h3 className="fw-bold mb-2">Your Wishlist is Empty</h3>
            <p className="text-muted mb-4">
              Save items you love by tapping the heart icon on any product.
            </p>
            <Link to="/collection" className="btn btn-primary rounded-pill px-4 py-3 fw-bold" style={{ background: "var(--accent)" }}>
              Explore Collections <FaArrowRight size={13} className="ms-1" />
            </Link>
          </div>
        ) : (
          <div className="row g-4">
            {wishlistItems.map((item) => (
              <div className="col-6 col-md-4 col-lg-3" key={item.id}>
                <div className="product-card-modern">
                  {/* Remove Button */}
                  <div className="position-absolute top-0 end-0 p-2" style={{ zIndex: 3 }}>
                    <button
                      type="button"
                      onClick={() => handleRemove(item.id)}
                      className="btn btn-sm bg-white shadow-sm rounded-circle d-flex align-items-center justify-content-center"
                      style={{ width: "32px", height: "32px", color: "var(--danger)", border: "none" }}
                      title="Remove from Wishlist"
                    >
                      <FaTrashAlt size={12} />
                    </button>
                  </div>

                  {/* Product Image */}
                  <Link
                    to={item.categorySlug ? `/collection/${item.categorySlug}/${item.slug}` : `/collection`}
                    className="product-card-img-wrap"
                  >
                    <img
                      src={getProductImageUrl(item.image)}
                      alt={item.name}
                      onError={handleProductImageError}
                    />
                  </Link>

                  {/* Body */}
                  <div className="product-card-body">
                    {item.categoryName && (
                      <span className="product-card-category">{item.categoryName}</span>
                    )}
                    <Link
                      to={item.categorySlug ? `/collection/${item.categorySlug}/${item.slug}` : `/collection`}
                    >
                      <h4 className="product-card-title">{item.name}</h4>
                    </Link>

                    <div className="product-card-price-row mb-3">
                      <span className="product-current-price">
                        Rs. {item.price ? Number(item.price).toLocaleString() : 0}
                      </span>
                    </div>

                    <button
                      type="button"
                      onClick={() => handleMoveToCart(item)}
                      className="btn btn-dark w-100 py-2 rounded-3 fw-bold d-flex align-items-center justify-content-center gap-2"
                      style={{ fontSize: "13.5px" }}
                    >
                      <FaShoppingBag size={13} /> Move to Cart
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
